import { getAuthToken, getImpersonationToken } from 'src/utils'

export const tokenService = {
  getToken(useAuthToken = false) {
    if (useAuthToken) {
      return getAuthToken()
    }

    return getImpersonationToken() || getAuthToken()
  },
}
